var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.10438H5.785L5.14 3.74938C5.05 3.84438 4.995 3.96938 4.995 4.10438C4.995 4.37938 5.22 4.60438 5.495 4.60438C5.635 4.60438 5.76 4.54938 5.85 4.45938L7.345 2.95937C7.435 2.86937 7.49 2.74437 7.49 2.60438C7.49 2.46438 7.435 2.33938 7.345 2.24937L5.85 0.749375C5.755 0.664375 5.63 0.609375 5.495 0.609375C5.22 0.609375 4.995 0.834375 4.995 1.10938C4.995 1.24937 5.05 1.37437 5.14 1.46438L5.785 2.10938H1C0.725 2.10938 0.5 2.33438 0.5 2.60938C0.505 2.88438 0.725 3.10438 1 3.10438ZM7 6.11438H2.215L2.86 5.46938C2.95 5.37437 3.005 5.24937 3.005 5.11438C3.005 4.83938 2.78 4.61438 2.505 4.61438C2.365 4.61438 2.24 4.66937 2.15 4.75938L0.655 6.25938C0.565 6.34937 0.51 6.47437 0.51 6.60938C0.51 6.74937 0.565 6.87437 0.655 6.96438L2.15 8.46438C2.245 8.55438 2.37 8.60938 2.505 8.60938C2.78 8.60938 3.005 8.38438 3.005 8.10938C3.005 7.96938 2.95 7.84438 2.86 7.75437L2.215 7.10938H7C7.275 7.10938 7.5 6.88438 7.5 6.60938C7.5 6.33437 7.275 6.11438 7 6.11438Z",
    fill: "#474D66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapHorizontal);
export default __webpack_public_path__ + "static/media/swap_horizontal.4371de14.svg";
export { ForwardRef as ReactComponent };